exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/**\n * Themings and color for POS app\n */\n.allergenSymbol {\n  color: #c21807;\n}\n.invalidStudentSymbol {\n  color: #ffa07a;\n}\n.specialMessageSymbol {\n  color: #4afb51;\n}\n.manuallyKeyedSymbol {\n  color: #17202a;\n}\n.arrowSymbol {\n  color: #4b8bb1;\n}\n.messageText {\n  color: #4b8bb1;\n  font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/symbolIndicator.less
// module id = 3170
// module chunks = 0